//公共模版
const stenManageEn = {
  stenManageLang: {
    公共模版: 'Public template',
    电价模版: 'Electricity price template',
    请输入内容例如模版名称标签: 'Please enter the content, such as template name, label',
    查询: 'Query',
    重置: 'Reset',
    创建模板: 'Create a template',
    模版名称: 'Template name',
    标签: 'Label',
    创建人: 'Founder',
    创建时间: 'Creation time',
    操作: 'Operation',
    查看: 'Examine',
    引用创建: 'Reference creation',
    编辑: 'Edit',
    是否确认删除该模板: 'Do you want to delete the template?',
    删除: 'Delete',
    暂无数据: 'No data available',
    模板详情: 'Template details',
    模板名称: 'Template name',
    模板标签: 'Template tag',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    时段: 'Time frame',
    买入电价元kWh: 'Purchase price (Yuan /kWh)',
    卖出电价元kWh: 'Selling price (Yuan /kWh)',
    尖: 'Tip',
    峰: 'Peak',
    平: 'Flat',
    谷: 'Valley',
    确定: 'Confirm',

    模版编辑: 'Template editor',
    基础信息: 'Basic information',
    时段与电价: 'Time period and price',

    请输入模版名称: 'Please enter a template name!',
    标签名称: 'Label name',
    请输入标签名称: 'Please enter a label name!',
    生成: 'Generate',
    '标签名称以空格分隔，完成后回车或点击“生成”按钮即可生成标签。每个标签最多可输入20个字符，最多支持生成10个标签':
      'Label names are separated by Spaces. Press enter or click the "Generate" button to generate labels. A maximum of 20 characters can be entered for each label, and a maximum of 10 labels can be generated.',
    标签管理: 'Label management',
    取消: 'Cancel',
    点击编辑后可以勾选标签后进行删除操作: 'After clicking "Edit", you can select the label and delete it',
    确定修改: 'Definite modification',
    下一步: 'next step',
    最多还可添加: 'Can I add at most',
    个标签: 'Tags',
    单个标签字符长度不可超过20: 'A single label contains a maximum of 20 characters',
    请选择要删除的标签: 'Select the label you want to remove',
    时间编辑: 'Time editing',
    选择时间: 'Selection time',
    时段说明: 'Period specification',
    请选择: 'Please select',
    新增: 'Newly increased',
    电价编辑: 'Electricity price editing',
    买入价格: 'Purchase price',
    元: '',
    卖出价格: 'Sell price',
    确定添加: 'Definite addition',
    请选择开始时间: 'Please select a start time!',
    开始时间不可与结束时间相同: 'The start time cannot be the same as the end time!',
    选择结束时间: 'Please select a end time!',
    结束时间不可与开始时间相同: 'The end time cannot be the same as the start time!',
    请选择时间段类型: 'Please select a time period type!',
    请输入买入价格: 'Please enter the purchase price',
    '买入价格数字范围 0 - 10000': 'Purchase price number range 0 - 10000',
    小数点后不允许超过9位: 'No more than 9 digits are allowed after the decimal point',
    请输入卖出价格: 'Please enter sell price!',
    '卖出价格数字范围 0 - 10000': 'Sell price number range 0 - 10000',
    时间段存在冲突请重新配置: 'Time range conflict, please reconfigure!',
    主动绑定: 'Active binding',
    确认: 'Affirm',
    选择年月: 'Choose the year and month',
    选择年份: 'Choose the year',
    全部: 'All',
    选择电站: 'Choosing a power station',
    选择地区: 'Choose the area',
    未绑定电站: 'Unbound power station',
    已选: 'Selected',
    请输入内容: 'Please enter the content',
    '01月': 'January',
    '02月': 'February',
    '03月': 'March',
    '04月': 'April',
    '05月': 'May',
    '06月': 'June',
    '07月': 'July',
    '08月': 'August',
    '09月': 'September',
    '10月': 'October',
    '11月': 'November',
    '12月': 'December',

    提示: 'Hint',
    '当前配置信息如下，请确认是否绑定': 'The current configuration information is as follows, please confirm whether to bind!',
    年: 'Year',
    电站: 'Power station',
    月: 'Month',
    年月: 'Year month',
    请选择绑定月份: 'Please select the binding month!',
    请选择绑定电站: 'Please select the binding station!'
  }
}
export default stenManageEn
